import fields from '../Field.constants';

export const isUpdatingField = (updates, field) => updates.reduce((result, update) => {
    if (update.field === field) {
        return true;
    }
    return result;
}, false);

export const updateReadyForApproval = updates => isUpdatingField(updates, fields.ReadyForApproval);

export const updateReleaseDate = updates => isUpdatingField(updates, fields.ContractReleaseDate);

export const updateEndDate = updates => isUpdatingField(updates, fields.ContractEndDate);

export const updateEMarkingStartDate = updates => isUpdatingField(updates, fields.E_MarkingStartDate);

export const updateEMarkingEndDate = updates => isUpdatingField(updates, fields.E_MarkingEndDate);
